import type { BlobLike } from "@pdfking/compatibility"
import type { AsyncSequence, Bytes } from "@pdfking/tfunc"

// Input parameters for PDFReader

export type PDFReaderOptions = {
  icc?: string
  password?: string
  size: Bytes
  stream: AsyncSequence<BlobLike>
  type: string
}
